import { FunctionComponent as F, useState } from "react";
import FolderIcon from '@mui/icons-material/Folder';
import FolderOpenIcon from '@mui/icons-material/FolderOpen';
import Stack from "@mui/material/Stack";
import { useSelector } from 'react-redux';
import { IState } from "../../../core/store/store";
import TooltipIfTruncated from "../TooltipIfTruncated";
import FoldersList from "./FoldersList";
import { Box } from "@mui/material";


export interface Asset
{
  parentFolderId?: number
  folderId?: number,
  protocolId?: number
}

export interface Props
{
  asset: Asset,
  folderId?: number,
  indent?: number,
  selectedFolderId?: number,
  selectFolder: (folderId?: number) => void;
}

const Folder: F<Props> = (props: Props) =>
{
  const name = useSelector((state: IState) => state.protocol.folders
    .find(f => f.folderId === props.folderId)?.name) || 'Root';

  const assetParentFolderId = props.asset.protocolId ? props.asset.folderId : props.asset.parentFolderId;
  const currentParent = (props.folderId || undefined) === assetParentFolderId;
  const currentFolder = props.folderId === props.asset.folderId;
  const selectable = !currentParent && !currentFolder;
  const selected = props.folderId === props.selectedFolderId;
  const expandable = props.asset.protocolId || !currentFolder;

  const [expanded, setExpanded] = useState(props.asset.protocolId ? true : expandable);

  const handleClick = () =>
  {
    if(props.asset.protocolId || !currentFolder)
      setExpanded(!expanded);

    if(selectable)
      props.selectFolder(props.folderId);
  };

  return (
    <Box sx={{pl: (props.folderId ? 8 : 0) + 'px'}}>
      <Stack
        direction='row'
        onClick={handleClick}
        width={500 - 8 * (props.indent || 0) + 'px'}
        sx={{ backgroundColor: selected ? '#DDDDDD' : 'transparent', cursor: 'pointer' }}>
        {expanded ?
          <FolderOpenIcon color={!selectable ? 'disabled' : undefined} sx={{ mr: '15px' }}/> :
          <FolderIcon color={!selectable ? 'disabled' : undefined} sx={{ mr: '15px' }}/>}
        <TooltipIfTruncated text={name} typographyProps={{ color: !selectable ? 'gray' : undefined }}/>
      </Stack>
      {expanded ? <FoldersList
        {...props}
        folderId={props.folderId || undefined}
        indent={(props.indent || 0) + 1}/> : <></>}
    </Box>);
}

export default Folder;

